import { Price } from '@common/components/Price';
import { useTranslations } from '@lang';
import { Item } from 'shared-types';
import { BasketDrawerTextWrapper, BasketItemText, Listing } from '../BasketDrawer.styles';

export const ProductListing = ({ products }: { products: Item[] }) => {
  const { t } = useTranslations();
  return (
    <Listing>
      {products.map((product) => {
        return (
          <div data-testid="product-listing" key={product.id}>
            <BasketDrawerTextWrapper>
              <BasketItemText>{product?.product?.name}</BasketItemText>
              {product.option && <BasketItemText>{product.option.name}</BasketItemText>}
              <BasketItemText>
                <Price price={product.price} />
              </BasketItemText>
              <BasketItemText>
                {t('basketDrawer.productListing.quantity')}: {product.quantity}
              </BasketItemText>
            </BasketDrawerTextWrapper>
          </div>
        );
      })}
    </Listing>
  );
};
